module.exports = __webpack_public_path__ + "static/media/BarChart.6eb47a7b.svg";